import {useMemo} from 'react';

import {typography} from '@/utilites/typography/typography';

export function useMemoTypography(text) {
	return useMemo<string>(() => {
		return typography(text);
	}, [text]);
}
